import React from 'react';
import './blog.styl';
import Footer from '../components/Footer';
import { Canonical } from '.';
import '../styles/global.css';

export default function Blog({ children, location }) {
  return (
    <div className="Blog">
      <Canonical location={location} />

      {children}
      <Footer />
    </div>
  );
}
